export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL'
export const AJAX_CALL_SUCCESS = 'AJAX_CALL_SUCCESS'
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR'

export const AUTH_USER = 'AUTH_USER'

export const GET_PROFILE = 'GET_PROFILE'